import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { Redirect } from "react-router-dom";
import "./style.scss";
export default function Title(props) {
  const [redirect, setRedirect] = React.useState(false);
  const handleClickLogOut = () => {
    localStorage.setItem("authStatus", false);
    setRedirect(true);
  };

  return (
    <>
      {redirect ? <Redirect to="/admin_l7" /> : ""}
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        {props.children}
        <div className="logout" onClick={handleClickLogOut}>
          <ExitToAppIcon className="logout-icon" />
          <button className="logout-button">LogOut</button>
        </div>
      </Typography>
    </>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};
